import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ActivityLogger } from '@/lib/activityLogger';

interface ActivityTrackingProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that automatically tracks page views and route changes
 */
export function ActivityTrackingProvider({ children }: ActivityTrackingProviderProps) {
  const location = useLocation();

  useEffect(() => {
    // Log page view on route change
    ActivityLogger.pageView(location.pathname, document.title);
  }, [location.pathname]);

  return <>{children}</>;
}
